// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunk." + chunkId + "." + "f6489b1c8d5e2d7e028f" + ".css";
};